import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
import CartSummary from '../../parent/subscription/components/CartSummary';
import CheckoutForm from '../../parent/subscription/components/CheckoutForm';
import Divider from './CustomDivider';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { API } from 'aws-amplify';
import useSnack from 'hooks/useSnack';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB);

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    paddingTop: 16,
    paddingBottom: 16,
  },
  btn: {
    paddingLeft: 50,
    paddingRight: 50,
  },
  card: {
    boxShadow: 'none',
    backgroundColor: '#F8F9FC',
    width: '100%'
  },
  cardBody: {
    '& h5': {
      display: 'none',
    },
  },
  field: {
    marginBottom: theme.spacing(1),
  },
  root: {
    backgroundColor: '#FFECE4',
    maxWidth: 620,
    // margin: 'auto',
    padding: theme.spacing(3),
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(4)
  },
  inputRoot: {
    background: theme.palette.action.disabledBackground,
  },
  inputFocused: {
    borderColor: 'transparent',
    backgroundColor: theme.palette.primary.light,
  },
}));

const Payment = ({ onChange, data, product, onSubmit, showAgreement }) => {
  const classes = useStyles();
  const snack = useSnack();
  const [coupon, setCoupon] = useState();

  const onCouponChange = (e) => {
    onChange({
      ...data,
      coupon: e.target.value,
    });
  };

  const onRefCodeChange = (e) => {
    onChange({
      ...data,
      referralCode: e.target.value,
    });
  }

  const onSubmitCoupon = () => {
    return API.post('public', `/stripe/coupons/verify`, {
      body: { coupon: data.coupon, product: product.stripe_product_id },
    }).then(
      (resp) => {
        if (!resp) {
          snack.error('Invalid coupon code');
          onChange({
            ...data,
            coupon: '',
          });
        } else if (resp.valid) {
          snack.success('Coupon code successfully applied!');
        }
        setCoupon(resp);
      },
      (e) => {
        snack.error(e.message);
      },
    );
  };

  return (
    <div>
      {/*<Box marginBottom={3}>*/}
      {/*  <Button*/}
      {/*    startIcon={<ArrowBackIcon />}*/}
      {/*    color="primary"*/}
      {/*    onClick={() => setStep(2)}*/}
      {/*  >*/}
      {/*    Go Back*/}
      {/*  </Button>*/}
      {/*</Box>*/}
      <Elements stripe={stripePromise} options={{
        fonts: [
          {
            cssSrc: 'https://fonts.googleapis.com/css2?family=Arimo:wght@400&display=swap',
          },
        ],
      }}>
        <Box>
          <Box maxWidth={620}>
            {/* <Divider /> */}
            <Typography align='center' gutterBottom variant="h3">
              Plan Info
            </Typography>
            <Box marginTop={5}>
              <CartSummary
                plan={product}
                couponCode={data.coupon}
                coupon={coupon}
                onCouponChange={onCouponChange}
                onSubmitCoupon={onSubmitCoupon}
              />
            </Box>
            <Box mb={3}>
              <OutlinedInput
                fullWidth
                classes={{
                  root: classes.inputRoot,
                  focused: classes.inputFocused,
                }}
                size="large"
                placeholder="Do you have a referral code?"
                value={data.referralCode}
                onChange={onRefCodeChange}
              />
            </Box>
            { product.service_details && (
              <Box marginTop={3} marginBottom={6}>
                <div className="rich-text-content" dangerouslySetInnerHTML={{__html: product.service_details }} />
              </Box>
            )}
          </Box>
          <Box className={classes.root}>
            <Divider />
            <CheckoutForm showAgreement={showAgreement} onToken={onSubmit} />
          </Box>
        </Box>
      </Elements>
    </div>
  );
};

export default Payment;
